export const lv = {
    LEFT: 'Pa kreisi: Pārietu uz iepriekšējo dienu.',
    RIGHT: 'Pa labi: Pāriet uz nākamo dienu.',
    DOWN: 'Uz leju: lai Pārietu uz nākamo rindu.',
    UP: 'Uz augšu: lai Pārvietotos uz iepriekšējo rindu.',
    PGUP: 'PgUp: Pārietu uz iepriekšējo mēnesi.',
    PGDOWN: 'PgDown: Pārietu uz nākamo mēnesi.',
    HOME: 'Mājas: Pārietu uz iepriekšējo gadu.',
    END: 'Beigas: Pārietu uz nākamo gadu.',
    ESC: 'Esc/Šodien/Aizvērt: aizvērt kalendāru.',
    TITLE: 'Tastatūras Instrukcijas'
};
